module.exports = __webpack_public_path__ + "static/industries-retail-image-7291f22befc1bd6d141246e7656afd4e.jpg";